import { render, staticRenderFns } from "./PriceInput.vue?vue&type=template&id=2b144ac6&"
import script from "./PriceInput.vue?vue&type=script&setup=true&lang=js&"
export * from "./PriceInput.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports